"use client";

import { FormEvent, useState } from "react";

export function RegisterForm() {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [isPending, setIsPending] = useState(false);

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setError("");
    setSuccess("");

    if (password !== confirmPassword) {
      setError("Passwörter stimmen nicht überein.");
      return;
    }

    setIsPending(true);

    try {
      const response = await fetch("/api/register", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ firstName, lastName, email, password }),
      });

      const payload = (await response.json().catch(() => null)) as { error?: string } | null;
      if (!response.ok) {
        setError(payload?.error ?? "Registrierung fehlgeschlagen.");
        return;
      }

      setSuccess("Konto wurde erstellt. Ein Admin muss die Registrierung zuerst freigeben.");
      setFirstName("");
      setLastName("");
      setEmail("");
      setPassword("");
      setConfirmPassword("");
    } catch {
      setError("Registrierung fehlgeschlagen.");
    } finally {
      setIsPending(false);
    }
  };

  return (
    <form className="stack-sm" onSubmit={handleSubmit}>
      <label className="field">
        <span>Vorname</span>
        <input
          autoComplete="given-name"
          name="firstName"
          onChange={(event) => setFirstName(event.target.value)}
          required
          type="text"
          value={firstName}
        />
      </label>

      <label className="field">
        <span>Nachname</span>
        <input
          autoComplete="family-name"
          name="lastName"
          onChange={(event) => setLastName(event.target.value)}
          required
          type="text"
          value={lastName}
        />
      </label>

      <label className="field">
        <span>E-Mail</span>
        <input
          autoComplete="email"
          name="email"
          onChange={(event) => setEmail(event.target.value)}
          required
          type="email"
          value={email}
        />
      </label>

      <label className="field">
        <span>Passwort</span>
        <input
          autoComplete="new-password"
          minLength={6}
          name="password"
          onChange={(event) => setPassword(event.target.value)}
          required
          type="password"
          value={password}
        />
      </label>

      <label className="field">
        <span>Passwort wiederholen</span>
        <input
          autoComplete="new-password"
          minLength={6}
          name="confirmPassword"
          onChange={(event) => setConfirmPassword(event.target.value)}
          required
          type="password"
          value={confirmPassword}
        />
      </label>

      {error ? <p className="error-text">{error}</p> : null}
      {success ? <p className="feedback-success">{success}</p> : null}

      <button className="btn btn-outline" disabled={isPending} type="submit">
        {isPending ? "Registrierung läuft..." : "Registrieren"}
      </button>
    </form>
  );
}
